import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { pdfFIle as pdfIcon, Success } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, GHOST_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { Col, Row } from '@yme/atoms/grid';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { downloadPDF, getPdfSizeLabel } from '@yme/components/ReturnForm/helpers';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRTL } from '@yme/selectors/index';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ButtonsContainerStyled, DescriptionLabelStyled, HeaderStyled, InfoBlockContainerStyled, TitleContainerStyled, TitleLabelStyled, } from './FinalStepStyled';
import { ContentContainerStyled, DownLoadButtonStyled, FileNameStyled, FileSizeStyled, FlexWrapperStyled, } from './styled';
export const FinalStep = memo(({ isSuccess, stepData, headerLabel, descriptionLabel, pdfFile, navigate, }) => {
    const { isMobileView } = useWindowSize();
    const isRTL = useSelector(getRTL);
    const { t } = useTranslation();
    const backButtonLabel = stepData.darkButton?.text;
    const backButtonLink = stepData.darkButton?.link;
    const forwardButtonLabel = stepData.lightButton?.text;
    const forwardButtonLink = stepData.lightButton?.link;
    const pdfFileUint8Array = useMemo(() => (pdfFile ? new Uint8Array(pdfFile) : null), [pdfFile]);
    const handleDownloadClick = useCallback(() => {
        if (!pdfFileUint8Array) {
            return;
        }
        downloadPDF(pdfFileUint8Array);
    }, [pdfFileUint8Array]);
    return (React.createElement(FlexWrapperStyled, { flexDirection: "column", isRightToLeft: isRTL },
        React.createElement(ContentContainerStyled, { width: "100%" },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 8 },
                    React.createElement(InfoBlockContainerStyled, { isSuccess: isSuccess, flexDirection: "column", alignItems: "flex-start", paddingDesktop: "48px", paddingTablet: "24px", padding: "24px 16px", mbDesktop: "24px", mbTablet: "32px", mb: "32px" },
                        React.createElement(HeaderStyled, null,
                            React.createElement(TitleContainerStyled, null,
                                React.createElement(TitleLabelStyled, null, headerLabel),
                                React.createElement(SVGIcon, { type: Success, size: ICON_SIZE.xs })),
                            React.createElement(DescriptionLabelStyled, null, descriptionLabel)),
                        pdfFileUint8Array && (React.createElement(DownLoadButtonStyled, { contentColor: colorCoreBlack900Base, onClick: handleDownloadClick },
                            React.createElement(SVGIcon, { size: ICON_SIZE.m, type: pdfIcon }),
                            React.createElement(FileNameStyled, null, t('returnForm_successDownloadPdf_label')),
                            "\u00A0",
                            React.createElement(FileSizeStyled, null, getPdfSizeLabel(pdfFileUint8Array?.byteLength)))),
                        React.createElement(ButtonsContainerStyled, { flexDirection: isMobileView ? 'column' : 'row', gap: "12px" },
                            backButtonLabel && backButtonLink && (React.createElement(Button, { as: "span", size: SIZE_44, buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, label: backButtonLabel, width: "auto", onClick: () => {
                                    navigate(backButtonLink);
                                } })),
                            forwardButtonLabel && forwardButtonLink && (React.createElement(Button, { as: "span", size: SIZE_44, buttonVariant: GHOST_VARIANT, hasIconButton: NO_ICON, label: forwardButtonLabel, width: "auto", onClick: () => {
                                    navigate(forwardButtonLink);
                                } })))))))));
});
FinalStep.displayName = 'FinalStep';
